'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var parts = ['container', 'item', 'heading', 'button', 'panel', 'icon', 'squareIcon'];

// same as in card.ts
var defaultP = {
  base: 4,
  md: 6
};
var baseStyleContainer = {
  '& > *:not(style)~*:not(style)': {
    mt: 2
  }
};
var baseStyleItem = {
  layerStyle: 'card'
};
var baseStyleButton = function baseStyleButton(props) {
  var c = props.colorScheme;
  return {
    transitionProperty: 'common',
    transitionDuration: 'normal',
    fontSize: '1em',
    color: c === 'black' || c === 'gray' ? "gray.500" : "".concat(c, ".400"),
    p: defaultP,
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed'
    },
    _focus: {}
  };
};
var baseStyleHeading = function baseStyleHeading(props) {
  props.colorScheme;
  return {
    textStyle: 'heading',
    fontSize: '2xl',
    textAlign: 'left',
    // When icon/arrow is left, add padding to the left.
    '.chakra-accordion__square-icon + &, .chakra_accordion__arrow + &': {
      pl: 4
    },
    // When icon/arrow is right, align icon/arrow to the right.
    '& + .chakra-accordion__square-icon, & + .chakra-accordion__arrow': {
      ml: 'auto'
    },
    // Safety padding to prevent icon/arrow from overlapping heading.
    pr: 1
  };
};

// no pt because pb is taken from baseStyleHeading
var baseStylePanel = {
  px: defaultP,
  pb: defaultP
};
var baseStyleArrow = {
  fontSize: '1em'
};
var baseStyleSquareIcon = function baseStyleSquareIcon(props) {
  return {
    borderRadius: 'md',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 1.5,
    bg: 'gray.400',
    color: 'white',
    fontSize: '1.25em'
  };
};
var baseStyle = function baseStyle(props) {
  return {
    container: baseStyleContainer,
    item: baseStyleItem,
    heading: baseStyleHeading(props),
    button: baseStyleButton(props),
    panel: baseStylePanel,
    arrow: baseStyleArrow,
    squareIcon: baseStyleSquareIcon()
  };
};
var defaultProps = {
  colorScheme: 'black'
};
var Accordion = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = Accordion;